module.exports = "/static/img/css3.svg?683750a2a1da8ad2181a91844f8976ab";